module.exports = __webpack_public_path__ + "img/15.01b0b50e.svg";